import React, { useEffect, useState } from 'react';
import PropTypes, { func } from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import GetAppIcon from '@material-ui/icons/GetApp';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';


const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '35px',
    display: 'flex',
    alignItems: 'center',
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  buttonDelete: {
    backgroundColor: '#DC004E'
  },
  buttons: {
    marginLeft: 15,
  }
}));

const VisitaFiliadoVisualizacaoToolbar = props => {
  const {
    className,
    history,
    deleteVisita,
    downloadPDF,
    ...rest } = props;

  const classes = useStyles();
  const [modoAnonimo, setModoAnonimo] = useState(false);

  useEffect(() => {
    const anonimo = JSON.parse(localStorage.getItem('modoAnonimo'));
    setModoAnonimo(anonimo);
  }, []);

  const cancelarInsercao = () => {
    history.goBack();
  };



  return (

   <Grid
    container
    spacing={1}
   >
     <Grid
      item
      md={2}
      xs={12}
     >
       <Button
         color="primary"
         variant="outlined"
         fullWidth
         onClick={cancelarInsercao}
         className={classes.button}
         startIcon={<ArrowBackIcon />}
       >
         Voltar
       </Button>
     </Grid>
     <Hidden xsDown>
       <Grid
         item
         md={modoAnonimo ? 8 : 6}
         xs={12}
       >
       </Grid>
     </Hidden>
     {
       !modoAnonimo &&
       <Grid
         item
         md={2}
         xs={12}
       >
         <Button
           variant="contained"
           fullWidth
           color={'primary'}
           className={classes.buttonDelete}
           startIcon={<DeleteIcon />}
           onClick={deleteVisita}
         >
           APAGAR VISITA
         </Button>
       </Grid>
     }
     <Grid
       item
       md={2}
       xs={12}
     >
       <Button
         variant="outlined"
         fullWidth
         color={'primary'}
         startIcon={<GetAppIcon />}
         onClick={downloadPDF}
       >
         DOWNLOAD
       </Button>
     </Grid>
   </Grid>
  );
};

VisitaFiliadoVisualizacaoToolbar.propTypes = {
  className: PropTypes.string
};

export default VisitaFiliadoVisualizacaoToolbar;
